import { getLocale } from "../runtime";

const sv_totalpriceincvat = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Totalpris (inkl. moms)`
};

const totalpriceincvat = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_totalpriceincvat(inputs)
	return "totalPriceIncVat";
};

export { totalpriceincvat as "totalPriceIncVat" };